import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', loadChildren: () => import('../app/modules/list/list.module').then((mod) => mod.ListModule) },
  { path: 'card', loadChildren: () => import('../app/modules/card/card.module').then((mod) => mod.CardModule) },
  // { path: 'card/:uid', loadChildren: () => import('../app/modules/race-map/race-map.module').then((mod) => mod.RaceMapModule) },
  { path: 'org', loadChildren: () => import('../app/modules/org/org.module').then((mod) => mod.OrgModule) },
  { path: 'privacy', loadChildren: () => import('../app/modules/privacy/privacy.module').then((mod) => mod.PrivacyModule) },
  { path: 'email_confirm_success', loadChildren: () => import('../app/modules/email-confirm-success/email-confirm-success.module').then((mod) => mod.EmailConfirmSuccessModule) },
  { path: 'profile', loadChildren: () => import('../app/modules/profile/profile.module').then((mod) => mod.ProfileModule) },
  { path: 'race_form', loadChildren: () => import('../app/modules/race-form/race-form.module').then((mod) => mod.RaceFormModule) },
  { path: 'progress', loadChildren: () => import('../app/modules/progress/progress.module').then((mod) => mod.ProgressModule) },
  { path: 'auth-widget', loadChildren: () => import('../app/modules/race-auth-widget/race-auth-widget.module').then((mod) => mod.RaceAuthWidgetModule) },
];

const config: ExtraOptions = { scrollPositionRestoration: 'enabled' };
@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
